export function updateContactNameOnConversation(data) {
  return {
    type: '@ANSWERED_CONVERSATION/UPDATE_CONTACT_NAME',
    payload: {
      data
    }
  };
}

export function updateContactTagOnConversation(data) {
  return {
    type: '@ANSWERED_CONVERSATION/UPDATE_CONTACT_TAG',
    payload: {
      data
    }
  };
}
